import { FormBase } from "core/components";

export default class FacilityInventoryCountFileUploadForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "file",
                    label: "FACILITY_INVENTORY.FILE_UPLOAD.FILE_LABEL",
                    placeholder: "FACILITY_INVENTORY.FILE_UPLOAD.FILE_PLACEHOLDER",
                    type: "file"
                }
            ]
        };
    }
}